require.register("modules/bsc-intro/bsc-intro-activity/page-1/page-1", function(exports, require, module){
  var BaseExtension = require('base-extension');
var _ = window._ || require('lodash');

var page1 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page1;


  
});

